<template>
  <div
    :class="$b()"
  >
    <VisionLink
      display="block"
      :href="activeVariantUrl"
    >
      <DynamicImg
        :class="$b('image')"
        :sku="activeVariant.imageSKU"
        :width="400"
        :height="400"
        lazy-load
      />

      <p
        v-if="activeVariant.title"
        :class="$b('title')"
      >
        {{ activeVariant.title }}
        <span
          v-if="activeVariant.titleSuffix"
          :class="$b('title-suffix')"
        >{{ activeVariant.titleSuffix }}</span>
      </p>
      <span
        v-else-if="!pretitle && activeVariant.subTitle"
        :class="$b('subtitle')"
      >
        {{ parseText(activeVariant.subTitle) }}
      </span>
    </VisionLink>
  </div>
</template>

<script>
import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  name: 'ArticleTileProductCard',

  mixins: [parseTextMixin],

  props: {
    products: { type: Array, required: true },
    pretitle: { type: Boolean, default: false },
    prescriptionProduct: { type: Boolean, default: false },
  },

  setup() {
    const { resolveLocalePath } = useUrlBuilder()

    return { resolveLocalePath }
  },

  data() {
    return {
      activeVariantIndex: 0,
      frameTypes: {
        zf: 'Zero Frame',
        tf: 'Top Frame',
        bf: 'Base Frame',
        ff: 'Full Frame',
      },
    }
  },

  computed: {
    activeVariant() {
      return this.products[this.activeVariantIndex] || {}
    },

    activeVariantUrl() {
      const variantUrl = this.activeVariant.url
      if (this.prescriptionProduct) {
        const paramSeparator = variantUrl.includes('?') ? '&' : '?'
        return this.resolveLocalePath(
          variantUrl + `${paramSeparator}prescription=1`
        )
      }
      return this.resolveLocalePath(variantUrl)
    },

    outOfStockProductSkus() {
      return this.products
        .filter((product) => !product.inStock)
        .map((product) => product.sku)
    },

    preOrderProductSkus() {
      return this.products
        .filter((product) => product.onPreorder)
        .map((product) => product.sku)
    },
  },

  created() {
    if (this.outOfStockProductSkus.length) {
      this.outOfStockProductSkus.forEach((sku) => {
        this.$product.updateOutOfStockProductSkus(sku)
      })
    }

    if (this.preOrderProductSkus.length) {
      this.preOrderProductSkus.forEach((sku) => {
        this.$product.updatePreOrderProductSkus(sku)
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
.ArticleTileProductCard {
  @apply pb-xs;
}

.ArticleTileProductCard__section-title {
  @apply text-3xl pb-md md:hidden;
}

.ArticleTileProductCard__product {
  @apply mb-xs;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 100%;
}

.ArticleTileProductCard__section {
  flex: 1 0 auto;
  width: 100%;

  &--content {
    /*
      - Positions content over the ratio container to preserve dimensions.
      - If content exceeds ratio container height the element grows with the contnent.
    */
    transform: translateX(-100%);
    display: flex;
    flex-flow: column nowrap;
  }
}

.ArticleTileProductCard__image {
  @apply flex items-center rounded-md overflow-hidden;

  transform: scale(1) translateZ(0);
  transition: transform 0.5s ease;

  .ArticleTileProductCard:hover & {
    transform: scale(1.03) translateZ(0);
  }
}

.ArticleTileProductCard__title {
  @apply flex flex-wrap gap-2 items-baseline heading-3 mr-xxs mt-3 mb-0;
}

.ArticleTileProductCard__title-suffix {
  @apply text-xxs font-thin;
}

.ArticleTileProductCard__subtitle {
  @apply t-gradient;
}

.ArticleTileProductCard__pretitle {
  @apply inline font-thin;
}

.ArticleTileProductCard__subtitle,
.ArticleTileProductCard__pretitle {
  @apply text-mid-grey;
}

.ArticleTileProductCard__frame-type {
  @apply inline whitespace-nowrap mr-2;
}

.ArticleTileProductCard__price {
  @apply font-semibold text-base;
}

.ArticleTileProductCard__subtitle,
.ArticleTileProductCard__pretitle,
.ArticleTileProductCard__frame-type {
  @apply text-xs;
}

.ArticleTileProductCard__subtitle + .ArticleTileProductCard__prices {
  @apply ml-xxxs;
}

.ArticleTileProductCard__full-price {
  @apply ml-xxxs
    opacity-30 line-through;
}


</style>
